import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { onOpenChat } from '../../actions/chatModal';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectIsChatEnabled } from '../../selectors/chat';
import { TThunkDispatch } from '../../types/redux';

export function useChats(offer: IDailyRentOfferForMobileSite) {
  const isChatsEnabled = selectIsChatEnabled(offer);
  const { gaLabel, cianId: offerId } = offer;
  const dispatch = useDispatch<TThunkDispatch>();

  const handleOpenChat = useCallback(async () => {
    await dispatch(onOpenChat({ offerId, gaLabel }));
  }, [dispatch, gaLabel, offerId]);

  return useMemo(() => ({ isEnabled: isChatsEnabled, openChat: handleOpenChat }), [isChatsEnabled, handleOpenChat]);
}
